import { Button } from "@/components/ui/button";
import { MessageSquarePlus } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SidebarHeaderProps {
  isExpanded: boolean;
  onAnalysisClick: () => void;
}

export function SidebarHeader({
  isExpanded,
  onAnalysisClick,
}: SidebarHeaderProps) {
  if (isExpanded) {
    return (
      <div className="p-4">
        <div
          className="mb-4 cursor-pointer"
          onClick={onAnalysisClick}
          aria-label="Toggle sidebar"
        >
          <div className="flex items-center">
            <div className="flex items-center justify-center h-10 w-10 text-sky-500 font-bold text-lg bg-gray-900 rounded transition-transform hover:scale-105">
              <span>AX</span>
            </div>
            <span className="ml-2 text-xl font-bold">AnalystX</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="mb-4 flex justify-center cursor-pointer">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                onClick={onAnalysisClick}
                aria-label="Toggle sidebar"
                className="flex items-center"
              >
                <div className="flex items-center justify-center h-10 w-10 text-sky-500 font-bold text-lg bg-gray-900 rounded transition-transform hover:scale-105">
                  <span>AX</span>
                </div>
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p>Toggle Sidebar</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
}
